import React from 'react'
import BasicInfoForm from '../parts/basic_info'
import EmbededEntityInput from '../../input/embedded_entity'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'

const ContractItemBatchEdit = ({ store, label, disabledEntityFromBatch, ...rest }) => {
  const _ContractItemBatchEditForm = ({ record, updateFormField, errors }) => {
    return (
      <div className='row'>
        <div className='col-xs-12'>
          <SelectInput label={store.__('contract')} attr={'contract_id'} record={record}
            onChange={updateFormField} optionsrecord={store.options}
            optionsattr={'contracts'} labelattr={i => (i.name + ' | ' + i.id)}
            valueattr='id' errors={errors} />
          <BasicInfoForm store={store} updateField={updateFormField} record={record} errors={errors} />
        </div>
      </div>
    )
  }

  const attr = 'contract'

  return (
    <EmbededEntityInput label={label} store={store} attr={attr}
      disabled={!!disabledEntityFromBatch}
      edit_title={store.__('Edit contract')}
      add_title={store.__('Add contract')}
      errors={store.cv.errors}
      fields={[
        (attr, row) => (<OptionsField attr={attr} val={row[attr]}
          options={store.options.get('contracts')}
          Component={({ text }) => (text + ' | ' + row[attr])}
          labelattr='name' valueattr='id' />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />)

      ]}
      EditForm={_ContractItemBatchEditForm} {...rest}
    />
  )
}
export default ContractItemBatchEdit
